import { BaseWorkOrderParameterDto } from './base-work-order-parameter-dto';

export class WorkOrderStatusChangeParametersDto extends BaseWorkOrderParameterDto {
    status: string;
}
